/* Jhango HF header — sticky/transparent bar + premium menu drawer. Vanilla, namespaced. */
(function () {
  if (window.__jhangoHfHeader) return;
  window.__jhangoHfHeader = true;

  /* ─────────── sticky / transparent bar ─────────── */
  function initSticky() {
    var nav = document.getElementById('jhango-hf-header');
    if (!nav) return;
    var threshold = parseInt(nav.getAttribute('data-threshold'), 10) || 90;
    var useTransparent = nav.getAttribute('data-transparent') === 'true';
    if (useTransparent) document.body.classList.add('jhango-hf-transparent-header');

    function setH() {
      var bar = nav.querySelector('.jhango-hf-bar');
      document.documentElement.style.setProperty('--jhango-hf-header-h', (bar ? bar.offsetHeight : nav.offsetHeight) + 'px');
      document.documentElement.style.setProperty('--jhango-hf-nav-h', nav.offsetHeight + 'px');
    }
    // Robust scroll position — works whether the viewport or the <body> is the scroller
    // (body{overflow-x:hidden} can make the body the scroll container, zeroing window.scrollY).
    function readY() {
      return window.pageYOffset
        || (document.documentElement && document.documentElement.scrollTop)
        || (document.body && document.body.scrollTop)
        || 0;
    }
    var lastY = readY();
    // Announcement bar (rendered above the header in the header group). While it's on screen
    // the fixed header should sit just below it; as it scrolls off, the header slides up to top:0.
    var annEl = document.querySelector('.announcement-bar');
    // Belt-and-suspenders: strip any containing-block-creating props off the header-group
    // wrapper at runtime too (the theme's sticky-header sets will-change:transform via JS,
    // which would otherwise trap this position:fixed header and make it scroll away).
    (function () {
      var w = nav;
      while (w && w.nodeType === 1 && w !== document.body) {
        if (w.classList && (w.classList.contains('shopify-section-header') || w.classList.contains('shopify-section-group-header-group'))) {
          w.style.setProperty('will-change', 'auto', 'important');
          w.style.setProperty('transform', 'none', 'important');
        }
        w = w.parentElement;
      }
    })();
    // Direct, unthrottled handler — simplest possible reveal so nothing can leave it stuck.
    function update() {
      var y = readY();
      if (y < 0) y = 0;
      // pin the header just below the announcement bar while it's visible, then to the top
      if (annEl) {
        var ab = annEl.getBoundingClientRect().bottom;
        nav.style.top = (ab > 0 ? ab : 0) + 'px';
      }
      var solid = !useTransparent || y > threshold;
      nav.classList.toggle('is-solid', solid);
      nav.classList.toggle('is-transparent', !solid);
      nav.classList.toggle('is-stuck', y > 4);
      var revealZone = nav.offsetHeight + 80;
      if (y <= revealZone) {
        nav.classList.remove('is-hidden');           // near the top: always visible
      } else if (y > lastY) {
        nav.classList.add('is-hidden');              // scrolling down -> hide
      } else if (y < lastY) {
        nav.classList.remove('is-hidden');           // scrolling up -> reveal
      }
      lastY = y;
    }
    function onResize() { setH(); update(); }
    // Re-bind cleanly on every init; listen on window AND document(capture) so we catch the
    // scroll no matter which element is the scroller.
    if (window._jhfHdrScroll) {
      try { window.removeEventListener('scroll', window._jhfHdrScroll); } catch (e) {}
      try { document.removeEventListener('scroll', window._jhfHdrScroll, true); } catch (e) {}
    }
    if (window._jhfHdrResize) { try { window.removeEventListener('resize', window._jhfHdrResize); } catch (e) {} }
    window._jhfHdrScroll = update;
    window._jhfHdrResize = onResize;
    window.addEventListener('scroll', update, { passive: true });
    document.addEventListener('scroll', update, { passive: true, capture: true });
    window.addEventListener('resize', onResize);
    setH(); update();
    if (window.ResizeObserver) { try { new ResizeObserver(setH).observe(nav); } catch (e) {} }
  }

  /* ─────────── premium menu drawer ─────────── */
  function initDrawer() {
    var drawer = document.getElementById('jhango-hf-drawer');
    if (!drawer || drawer._jhfBound) return;
    drawer._jhfBound = true;
    var backdrop = document.getElementById('jhango-hf-drawer-backdrop');
    var lastFocus = null;

    function open(trigger) {
      lastFocus = trigger || document.activeElement;
      drawer.classList.add('is-open');
      // force inline styles so the panel always slides in + is opaque, even if a
      // theme rule ever overrides the stylesheet.
      drawer.style.transform = 'translateX(0)';
      drawer.style.visibility = 'visible';
      var bg = getComputedStyle(drawer).backgroundColor;
      if (bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent' || !bg) {
        drawer.style.background = '#ffffff';
        drawer.style.color = '#111111';
      }
      if (backdrop) {
        backdrop.classList.add('is-open');
        backdrop.style.opacity = '1';
        backdrop.style.visibility = 'visible';
      }
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('jhango-hf-noscroll');
      var f = drawer.querySelector('[data-jhango-hf-menu-close]');
      if (f) setTimeout(function () { f.focus(); }, 60);
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.style.transform = '';
      if (backdrop) {
        backdrop.classList.remove('is-open');
        backdrop.style.opacity = '';
        backdrop.style.visibility = '';
      }
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('jhango-hf-noscroll');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    drawer._jhfOpen = open; drawer._jhfClose = close;

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-jhango-hf-menu-open]');
      if (openBtn) { e.preventDefault(); open(openBtn); return; }
      if (e.target.closest('[data-jhango-hf-menu-close]')) { e.preventDefault(); close(); return; }
      var acc = e.target.closest('.jhango-hf-acc__toggle');
      if (acc) {
        e.preventDefault();
        var item = acc.closest('.jhango-hf-acc__item');
        if (item) {
          var willOpen = !item.classList.contains('is-open');
          item.classList.toggle('is-open', willOpen);
          acc.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        }
      }
    });
    if (backdrop) backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  function boot() {
    // The drawer is fully handled by the inline script inside the header section
    // (which is navigation-aware). Only run the sticky/auto-hide logic here to
    // avoid a second click handler that would block menu-link navigation.
    try { initSticky(); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', boot);              // safety net for defer/timing
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('page:loaded', boot);      // instant-navigation themes
})();
